<template>
  <!--
    ServicesSummary — summarizes ThinkSpatial's Service_Categories on the
    Home_Page (Requirement 4.2). The category list is driven by the fixed brand
    taxonomy via the Home content module, so the summary stays in step with the
    Service_Category enumeration without redesign.
  -->
  <section class="services" aria-labelledby="services-heading">
    <v-container>
      <ScrollReveal tag="div" class="services__head">
        <h2 id="services-heading" class="services__heading">
          {{ services.heading }}
        </h2>
        <p v-if="services.intro" class="services__intro">{{ services.intro }}</p>
      </ScrollReveal>

      <v-row class="services__grid">
        <v-col
          v-for="(category, index) in services.categories"
          :key="category.name"
          cols="12"
          sm="6"
          md="4"
        >
          <ScrollReveal tag="div" :delay="index * 60">
            <v-card class="services__card" variant="outlined" height="100%">
              <v-card-item>
                <v-card-title class="services__card-title">
                  {{ category.name }}
                </v-card-title>
              </v-card-item>
              <v-card-text v-if="category.description" class="services__card-body">
                {{ category.description }}
              </v-card-text>
            </v-card>
          </ScrollReveal>
        </v-col>
      </v-row>

      <!-- Through-link to the full capability set on the Services page. -->
      <ScrollReveal v-if="services.cta" tag="div" class="services__cta">
        <CtaButton :to="services.cta.to" :label="services.cta.label" />
      </ScrollReveal>
    </v-container>
  </section>
</template>

<script>
// ServicesSummary — Home_Page Service_Categories summary (Requirement 4.2).
import ScrollReveal from 'components/ScrollReveal.vue'
import CtaButton from 'components/CtaButton.vue'
import home from 'src/content/home'

export default {
  name: 'ServicesSummary',
  components: { ScrollReveal, CtaButton },
  data () {
    return {
      services: home.services
    }
  }
}
</script>

<style scoped>
.services {
  padding: 72px 0;
  background: #fff;
}

.services__head {
  text-align: center;
  max-width: 720px;
  margin: 0 auto 40px;
}

.services__heading {
  font-size: clamp(1.8rem, 4vw, 2.6rem);
  font-weight: 800;
  margin-bottom: 12px;
  color: #41281b;
}

.services__intro {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #4a4a4a;
}

.services__card {
  border-color: rgba(65, 40, 27, 0.12);
  transition: box-shadow 200ms ease, transform 200ms ease;
}

.services__card:hover {
  box-shadow: 0 10px 30px rgba(65, 40, 27, 0.12);
  transform: translateY(-2px);
}

.services__card-title {
  font-weight: 700;
  color: #41281b;
  white-space: normal;
}

.services__card-body {
  color: #4a4a4a;
  line-height: 1.6;
}

.services__cta {
  margin-top: 40px;
  text-align: center;
}
</style>
